/* ==========================================
   Video Grid - JavaScript
   ========================================== */

class VideoGrid extends HTMLElement {
  constructor() {
    super();
    this.modal = this.querySelector('.video-modal');
    this.playerContainer = this.querySelector('#video-player');
    this.triggers = this.querySelectorAll('[data-video-trigger]');
    this.closeButtons = this.querySelectorAll('[data-video-close]');
    this.videos = this.getVideoData();
  }

  connectedCallback() {
    this.initVideoTriggers();
    this.initCloseButtons();
    this.initEscapeKey();
    this.initRevealOnScroll();
  }

  getVideoData() {
    const scriptData = this.querySelector('script[type="application/json"]');
    return scriptData ? JSON.parse(scriptData.textContent) : {};
  }

  initVideoTriggers() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const videoId = trigger.dataset.videoTrigger;
        this.openModal(videoId);
      });
    });
  }

  initCloseButtons() {
    this.closeButtons.forEach(btn => {
      btn.addEventListener('click', () => this.closeModal());
    });
  }

  initEscapeKey() {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.modal.hidden) {
        this.closeModal();
      }
    });
  }

  openModal(videoId) {
    const videoData = this.videos[videoId];
    if (!videoData) return;

    // Create video element
    const video = document.createElement('video');
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;
    video.preload = 'none'; // Performance: load only on click
    video.className = 'video-modal__video';

    // Add sources
    videoData.sources.forEach(source => {
      const sourceEl = document.createElement('source');
      sourceEl.src = source.url;
      sourceEl.type = source.mimeType;
      video.appendChild(sourceEl);
    });

    // Clear and append
    this.playerContainer.innerHTML = '';
    this.playerContainer.appendChild(video);

    // Show modal with animation
    this.modal.hidden = false;
    requestAnimationFrame(() => {
      this.modal.classList.add('is-active');
    });
    document.body.style.overflow = 'hidden';

    // Play video (autoplay handles this, but fallback)
    video.play().catch(() => {});
  }

  closeModal() {
    this.modal.classList.remove('is-active');
    setTimeout(() => {
      this.modal.hidden = true;
      this.playerContainer.innerHTML = ''; // Clean up video to free memory
    }, 300); // Match CSS transition duration
    document.body.style.overflow = '';
  }

  initRevealOnScroll() {
    if (!this.hasAttribute('reveal-on-scroll')) return;

    const videoGrid = this.querySelector('.video-grid');
    if (!videoGrid) return;

    const items = videoGrid.querySelectorAll('[reveal-on-scroll="true"]');
    if (items.length === 0) return;

    // Use Intersection Observer for reveal on scroll
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const items = Array.from(videoGrid.querySelectorAll('[reveal-on-scroll="true"]'));
          
          items.forEach((item, index) => {
            setTimeout(() => {
              item.style.opacity = '1';
              item.style.transform = 'translateY(0)';
              item.removeAttribute('reveal-on-scroll');
            }, index * 50); // Stagger animation
          });
          
          observer.disconnect();
        }
      });
    }, { threshold: 0.1 });

    observer.observe(videoGrid);
  }
}

if (!window.customElements.get('video-grid')) {
  window.customElements.define('video-grid', VideoGrid);
}

